import React from 'react'

function Admin() {
  return (
    <div>
      
    </div>
  )
}

export default Admin
